window.rowStyleFormatter = function(row) {
    if (parseInt(row.highlight, 10) !== 1) {
        return {};
    }

    // Custom per-row colours keep the inline style.
    if (typeof row.background_color !== "undefined" || typeof row.color !== "undefined") {
        return {
            css: {
                "background-color": (typeof row.background_color !== "undefined") ? row.background_color : "#ffe6e6",
                "color": (typeof row.color !== "undefined") ? row.color : "#cc0000"
            }
        };
    }

    // Bootstrap contextual class renders correctly through table-striped / table-hover.
    return {
        classes: "table-warning"
    };
};
